import React from 'react';
import { Transaction } from '../mocks/mockData';
import { ExpenseCard } from './ExpenseCard';
import { clsx } from 'clsx';

interface TransactionListProps {
  transactions: Transaction[];
  title?: string;
  limit?: number;
  className?: string;
}

export function TransactionList({ 
  transactions, 
  title = "Recent Transactions", 
  limit,
  className 
}: TransactionListProps) {
  const displayedTransactions = limit ? transactions.slice(0, limit) : transactions;

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className={clsx('bg-white dark:bg-gray-800 rounded-lg border dark:border-gray-700 shadow-sm', className)}>
      <div className="p-6 border-b dark:border-gray-700">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
          {limit && transactions.length > limit && (
            <span className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 cursor-pointer">
              View all transactions
            </span>
          )}
        </div>
      </div>
      
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {displayedTransactions.length > 0 ? (
          displayedTransactions.map((transaction) => (
            <div key={transaction.id} className="p-4">
              <ExpenseCard transaction={transaction} />
            </div>
          ))
        ) : (
          <div className="p-8 text-center">
            <p className="text-gray-500 dark:text-gray-400">No transactions found</p>
          </div>
        )}
      </div>
      
      {limit && displayedTransactions.length > 0 && (
        <div className="p-4 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50 rounded-b-lg">
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">
              Total: {transactions.length} transactions
            </span>
            <span className="font-medium text-gray-900 dark:text-white">
              {formatCurrency(transactions.reduce((sum, t) => sum + t.amount, 0))}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}